import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'app-scrubber-calculation',
  templateUrl: './scrubber-calculation.component.html',
  styleUrls: ['./scrubber-calculation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ScrubberCalculationComponent implements OnInit {

  @Input() public calculationResponse: any;
  @Input() public toggleVal: string;
  @Input() public sidePanelScrubberData: any = [];
  @Input() public sidePanelScrubberShipData: any = [];
  @Input() public shipSidePanel:boolean = false;
  @Input() public viewDetailsSidePanel:boolean = false;

  accordionId: any = 'pp-accordion-val';
  expanded: boolean = true;
  isTitleClickable: boolean = true;
  showArrow: boolean = true;
  showBorder: boolean = true;
  accordionSettings: {
    isDisable: false
    showHover: true
    showCursorNotAllowed: false
    iconPosition: "end"
  }
  storeSidePanelData:any =[];
  sidePanelPoolData:any = [];
  formattedPoolNames = ''
  constructor() {
  }

  ngOnInit() {
    // if(this.viewDetailsSidePanel){
      this.sidePanelPoolData = [...this.sidePanelScrubberData?.poolLevelScrubberSavings || []];
      this.storeSidePanelData = this.sidePanelScrubberData?.poolLevelScrubberSavings?.map((items:any)=>({...items,
        sidePanelScrubberName:'Scrubber savings',sidePanelIFOConsumption:'Actual IFO consumption',
        sidePanelPYIFOConsumption:"Previous year's recognised consumption",sidePanelIFOCost:'Actual IFO cost',
        sidePanelPYIFOCost:"Previous year's recognised IFO cost"}
      ))
      const poolNames = this.sidePanelPoolData.map((item: any) => `Pool ${item?.poolName}`);
      if(poolNames.length === 0){
        this.formattedPoolNames = '';
      }else if (poolNames.length === 1) {
        this.formattedPoolNames = poolNames[0];
      } else if (poolNames.length === 2) {
        this.formattedPoolNames = poolNames.join(' and ');
      } else {
        const lastPool = poolNames.pop();
        this.formattedPoolNames = poolNames.join(', ') + ' and ' + lastPool;
      }
    // }else{
      // if(this.sidePanelScrubberShipData?.data?.length){
      //   console.log(this.sidePanelScrubberShipData)
      //   this.sidePanelScrubberShipData =  this.sidePanelScrubberShipData?.data[0];
      // }  
    // }
     console.log(this.sidePanelScrubberShipData)
    
    
   
  }
  
}